module.exports = function() {
  return new Worker(__webpack_public_path__ + "5efbdaa2719ad0d26cd4.worker.js");
};